import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input_number = _resolveComponent("oio-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_oio_input_number, {
      value: _ctx.realValue,
      placeholder: _ctx.readonly || _ctx.disabled ? '' : _ctx.placeholder,
      min: _ctx.min,
      max: _ctx.max,
      "min-safe-integer": _ctx.minSafeInteger,
      "max-safe-integer": _ctx.maxSafeInteger,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      step: _ctx.step,
      "add-step": _ctx.addStep,
      "reduce-step": _ctx.reduceStep,
      precision: _ctx.precision,
      unit: _ctx.unit,
      "show-thousandth": _ctx.showThousandth,
      autocorrection: _ctx.autocorrection,
      "onUpdate:value": _ctx.change,
      onFocus: _ctx.focus,
      onBlur: _ctx.blur
    }, null, 8, ["value", "placeholder", "min", "max", "min-safe-integer", "max-safe-integer", "disabled", "readonly", "step", "add-step", "reduce-step", "precision", "unit", "show-thousandth", "autocorrection", "onUpdate:value", "onFocus", "onBlur"]),
    _withDirectives(_createElementVNode("span", null, "可调整区域0~" + _toDisplayString(_ctx.removeDecimalZero(_ctx._formData.useAbleAmount)), 513), [
      [_vShow, _ctx._formData.useAbleAmount]
    ])
  ], 64))
}